import { render, staticRenderFns } from "./EditContractDialog.vue?vue&type=template&id=10a4b90a&scoped=true&"
import script from "./EditContractDialog.vue?vue&type=script&lang=js&"
export * from "./EditContractDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditContractDialog.vue?vue&type=style&index=0&id=10a4b90a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4b90a",
  null
  
)

export default component.exports